import { formatToMaxFourDigits } from '@flexo/general';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const InformationCardContentMemberLabelValue = ({ description, cardValue, metadata: _metadata, urlID: _urlID, id, KPIs = [] }) => {
  const { t } = useTranslation();
  const metadata = useSelector((state: any) => state.metadata);
  const { id: urlID } = useParams();
  const meta = _metadata || metadata;
  const url = _urlID || urlID;

  if (typeof description === 'string') {
    return (
      <div>
        <span className="paragraph">{t(description)}</span>
        <span className="paragraph">
          <span className="heading5">{cardValue?.value || '-.-'}</span>
        </span>
      </div>
    );
  } else if (Array.isArray(description)) {
    let allowedIndex = 1;
    const memberSitesTypes = [...meta?.sortedEntities?.communities?.map(c => c.members)?.flat() || []]?.find(m => m.memberId === url)?.sites?.map(s => s?.siteType?.[0]?.siteType) || [];
    if (memberSitesTypes?.includes('producer')) allowedIndex++;
    if (memberSitesTypes?.includes('prosumer')) allowedIndex = 3;
    if (memberSitesTypes?.includes('prosumage')) allowedIndex = 3;
    return (
      <div>
        {description.map((el, i, array) => {
          if (i < allowedIndex) {

            const kpi: any = (KPIs || []).find((kpi: any) => kpi?.name === el.value);

            return (
              <div key={`${id}-label-value-label-value-array-member-${i}`}>
                <span className={`color-hive-greyscale-600`}>
                  <span className="font-flexo-semibold heading5">{t(el.key)} </span>
                  {formatToMaxFourDigits(kpi?.value)}{kpi?.unit}
                </span>
                {i < array.length - 1 && <br />}
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  }
  return null;
};

export default InformationCardContentMemberLabelValue; 